import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FaShoppingCart } from "react-icons/fa"; // Import cart icon
import { useCart } from "../../CartContext/CartContextComp"; // Import cart context
import CartSlider from "../../CartSlider/CartSliderBar"; // Import cart slider

import Artwork from "../../../assets/images/Untitled_Artwork1.png";
import Artwork1 from "../../../assets/images/Untitled_Artwork 1.png";
import Artwork2 from "../../../assets/images/Untitled_Artwork 2.png";
import Artwork3 from "../../../assets/images/Untitled_Artwork 3.png";
import Artwork4 from "../../../assets/images/Untitled_Artwork 4.png";
import Umadras from "../../../assets/images/umadras.png";
import "../../../assets/css/UheroSection.css";

const Uherosection = () => {
  const navigate = useNavigate();
  const [cartOpen, setCartOpen] = useState(false); // State for cart slider
  const { cartItems } = useCart(); // Get cart items from context

  const handleContactClick = (e) => {
    e.preventDefault(); // Prevent default anchor behavior
    navigate("/umadras");

    setTimeout(() => {
      const contactSection = document.getElementById("contact");
      if (contactSection) {
        contactSection.scrollIntoView({ behavior: "smooth" });
      }
    }, 100);
  };

  return (
    <div>
      <nav className="navbar">
        <div className="ulogo">
          <Link to="/">
            <img src={Umadras} alt="Logo" className="ulogo-image" />
          </Link>
        </div>

        <div className="nav-links">
          <Link to="/">Home</Link>
          <Link to="/umadras/collections">Collection</Link>
          <Link onClick={handleContactClick}>Contact Us</Link>

          {/* Cart Icon */}
          <div className="cart-container" onClick={() => setCartOpen(true)}>
            <FaShoppingCart className="cart-icon" />
            {cartItems.length > 0 && <span className="cart-count">{cartItems.length}</span>}
          </div>
        </div>
      </nav>

      {/* Cart Slider */}
      {cartOpen && <CartSlider cartItems={cartItems} onClose={() => setCartOpen(false)} />}

      <div className="uhero-section">
        <div className="uimage-container">
          <img src={Artwork} alt="Design 1" />
          <img src={Artwork1} alt="Design 2" />
          <img src={Artwork2} alt="Design 3" />
          <img src={Artwork3} alt="Design 4" />
          <img src={Artwork4} alt="Design 5" />
        </div>
      </div>
    </div>
  );
};

export default Uherosection;
